import { Component } from "@angular/core";
import { AppLayoutComponent } from "../../../shared/components/app-layout/app-layout.component";

@Component({
    selector: "app-privacy-policy",
    imports: [AppLayoutComponent],
    templateUrl: "./privacy-policy.component.html",
    styleUrl: "./privacy-policy.component.scss"
})
export class PrivacyPolicyComponent {}
